import { fetchJson } from '../../customers/helpers/helpers';
import { serviceHelper } from '../../../../config/service-helper';
import { trackingContext } from '@jbhi-fi/components/src/Tracking';
import { toPascalCase } from '../../../../utils/common/objects';
import { getMultiTenancyHeaders } from '../../../../utils/multiTenancyHeaders';

export default class ReceiptHelper {
  validateStatus(status) {
    return status >= 200 && status < 500;
  }

  getDefaultReceiptApiHeaders = (accept = 'application/json') => {
    const newReceiptApiHeaders = serviceHelper.receiptApiKey
      ? {
          'x-jbg-api-key': serviceHelper.receiptApiKey,
          ...getMultiTenancyHeaders(),
        }
      : {};

    return {
      Accept: accept,
      'Content-Type': 'application/json;charset=UTF-8',
      ...newReceiptApiHeaders,
    };
  };

  // Get receipt data
  async getReceipt(receiptId) {
    const config = {
      headers: this.getDefaultReceiptApiHeaders(),
    };

    return toPascalCase(
      await fetchJson(`${serviceHelper.discoveryServiceUrl}${receiptId}`, config, this.validateStatus)
    );
  }

  // Send verification text message to mobile for receipt access only
  async sendReceiptVerification(receiptId) {
    const config = {
      method: 'POST',
      headers: this.getDefaultReceiptApiHeaders(),
    };

    return toPascalCase(await fetchJson(`${serviceHelper.discoveryServiceUrl}${receiptId}/SendVerification`, config));
  }

  // Verify receipt access request
  async verifyReceipt(receiptId, code, messageReference) {
    const config = {
      headers: {
        ...this.getDefaultReceiptApiHeaders(),
        'x-verification-code': code,
        'x-verification-reference': messageReference,
      },
    };

    return toPascalCase(await fetchJson(`${serviceHelper.discoveryServiceUrl}${receiptId}`, config));
  }

  // Download receipt as PDF
  async downloadReceipt(receiptId, receiptToken) {
    const config = {
      headers: this.getDefaultReceiptApiHeaders('application/pdf'),
    };

    if (receiptToken) {
      config.headers['x-token-receipt'] = receiptToken;
    }

    try {
      const response = await fetch(`${serviceHelper.discoveryServiceUrl}${receiptId}/Download`, config);
      if (response.ok) return await response.text();
      return toPascalCase(await response.json());
    } catch (error) {
      return { ErrorCode: 'FetchError' };
    }
  }

  redirectToAccount(receiptId, returnUrlParameters = {}) {
    const searchParams = new URLSearchParams({
      gtmCategory: 'eReceipts',
      gtmContext: trackingContext.receipts,
      ...returnUrlParameters,
    });

    window.location.href = `${window.location.origin}/account#/instore/${receiptId}?${searchParams}`;
  }
}
